import { useState, type ReactNode } from 'react';

const SESSION_KEY = 'pc_admin_auth';
const PASSWORD = 'Punto26!!';

interface LoginGateProps {
  children: ReactNode;
}

export default function LoginGate({ children }: LoginGateProps) {
  const [authed, setAuthed] = useState(() => sessionStorage.getItem(SESSION_KEY) === '1');
  const [input, setInput] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  if (authed) return <>{children}</>;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(SESSION_KEY, '1');
      setAuthed(true);
    } else {
      setError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
      setTimeout(() => setError(false), 2500);
    }
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">

        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src="https://static.readdy.ai/image/fab5168e291508d3586d4b84ed71e8b7/81e3031b4bcc562bb081a6ae4aa9af2c.png"
            alt="Punto Cassonetti"
            className="h-10 w-auto object-contain"
          />
        </div>

        {/* Card */}
        <div
          className={`bg-white rounded-2xl border border-[#E5E5E5] p-8 transition-all duration-100 ${shake ? 'translate-x-2' : ''}`}
          style={{ animation: shake ? 'shake 0.4s ease' : undefined }}
        >
          <div className="mb-6">
            <h1
              className="text-xl font-black text-[#000000] mb-1"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Accesso riservato
            </h1>
            <p className="text-xs text-[#A5A5A5]">
              Dashboard Conversioni · Punto Cassonetti
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="block text-xs font-bold text-[#555555] uppercase tracking-wide mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPwd ? 'text' : 'password'}
                  value={input}
                  onChange={(e) => { setInput(e.target.value); setError(false); }}
                  placeholder="••••••••"
                  autoFocus
                  className={`w-full border rounded-xl px-4 py-3.5 pr-11 text-sm focus:outline-none transition-all ${
                    error
                      ? 'border-red-400 focus:ring-2 focus:ring-red-400/20 bg-red-50'
                      : 'border-[#A5A5A5]/30 focus:border-[#7FCDCD] focus:ring-2 focus:ring-[#7FCDCD]/10'
                  }`}
                  style={{ fontFamily: "'DM Sans', sans-serif" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPwd((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center text-[#A5A5A5] hover:text-[#555555] transition-colors cursor-pointer"
                >
                  <i className={showPwd ? 'ri-eye-off-line' : 'ri-eye-line'} />
                </button>
              </div>
              {error && (
                <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1">
                  <i className="ri-error-warning-line" /> Password errata. Riprova.
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full flex items-center justify-center gap-2 bg-[#000000] hover:bg-[#222222] text-white font-black py-3.5 rounded-xl transition-colors text-sm cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              <i className="ri-lock-unlock-line" />
              Accedi alla dashboard
            </button>
          </form>
        </div>

        <p className="text-center text-[10px] text-[#A5A5A5] mt-5">
          Questa pagina è protetta e non indicizzata da Google.
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          20%       { transform: translateX(-6px); }
          40%       { transform: translateX(6px); }
          60%       { transform: translateX(-4px); }
          80%       { transform: translateX(4px); }
        }
      `}</style>
    </div>
  );
}
